import { useTranslation, Trans } from 'react-i18next';
import useInstallPrompt from '../hooks/useInstallPrompt';

export default function InstallCTA() {
  const { standalone, ios, canInstall, promptInstall } = useInstallPrompt();
  const { t } = useTranslation('home');

  if (standalone) {
    return (
      <div className="cps-install-cta-done">{t('installcta_done')}</div>
    );
  }

  return (
    <div className="cps-install-cta">
      <div className="cps-install-cta-text">
        <h4>{t('installcta_title')}</h4>
        <p>{t('installcta_body')}</p>
      </div>

      {canInstall && (
        <button className="cps-install-cta-btn" onClick={promptInstall}>{t('installcta_btn')}</button>
      )}

      {ios && (
        <div className="cps-install-cta-ios">
          <Trans t={t} i18nKey="installcta_ios" components={{ 1: <strong />, 3: <strong />, 5: <strong /> }} />
        </div>
      )}

      {!canInstall && !ios && (
        <div className="cps-install-cta-ios">{t('installcta_other')}</div>
      )}
    </div>
  );
}
